export class RSValidationHelper
{
	/**
	 * @param {string} email
	 * @returns {boolean}
	 */
	static isEmailValid(email)
	{
		if(!email.match(/\S+@\S+\.\S+/)) return false; // Jaymon's / Squirtle's solution
		else if((email.indexOf(' ') !== -1) || (email.indexOf('..') !== -1)) return false;

		return true;
	}


	/**
	 * @param {string} phoneNumber
	 * @param {?string} allowedChars
	 * @returns {boolean}
	 */
	static isPhoneNumberValid(phoneNumber, allowedChars = ' +()/.-')
	{
		return RSValidationHelper.isStringWithNumbers(phoneNumber, allowedChars);
	}


	/**
	 * @param {string} url
	 * @returns {boolean}
	 */
	static isUrlValid(url)
	{
		return /^(https?):\/\/[^\s$.?#].[^\s]*$/.test(url);
	}


	/**
	 * @param {string} string
	 * @param {?string} allowedChars
	 * @returns {boolean}
	 */
	static isStringWithNumbers(string, allowedChars = ' ')
	{
		let s;

		if ((allowedChars != null) && (allowedChars !== ''))
		{
			const dotPosition = allowedChars.indexOf('.');

			if ((dotPosition !== -1) && (dotPosition === (allowedChars.length - 1)))
			{
				if ((typeof console !== 'undefined') && (typeof console.warn !== 'undefined'))
				{
					console.warn(`RSValidationHelper.isPhoneNumberValid()\nThe char "." cannot be the last one in the string "${allowedChars}".`);
				}
			}

			const regexp = new RegExp(`[${allowedChars}]`, 'g');
			s = string.replace(regexp, '');
		}
		else
		{
			s = string;
		}

		return /^\d+$/.test(s);
	}
}
